var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_327_19624)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#8199F8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9994 20.1392C14.2835 20.1392 13.6471 20.0166 13.0903 19.7713C12.5368 19.526 12.0993 19.1847 11.7778 18.7472C11.4563 18.3097 11.2856 17.8042 11.2657 17.2308H13.135C13.1516 17.5059 13.2427 17.7462 13.4085 17.9517C13.5742 18.1539 13.7946 18.3113 14.0697 18.424C14.3448 18.5367 14.653 18.593 14.9944 18.593C15.359 18.593 15.6821 18.5301 15.9639 18.4041C16.2456 18.2749 16.466 18.0959 16.6251 17.8672C16.7842 17.6385 16.8621 17.375 16.8588 17.0767C16.8621 16.7685 16.7825 16.4967 16.6201 16.2614C16.4577 16.026 16.2224 15.8421 15.9142 15.7095C15.6092 15.5769 15.2413 15.5107 14.8105 15.5107H13.9106V14.0888H14.8105C15.1651 14.0888 15.475 14.0275 15.7401 13.9048C16.0086 13.7822 16.2191 13.6098 16.3715 13.3878C16.524 13.1624 16.5986 12.9022 16.5953 12.6072C16.5986 12.3189 16.5339 12.0687 16.4014 11.8565C16.2721 11.6411 16.0882 11.4737 15.8495 11.3544C15.6142 11.2351 15.3374 11.1754 15.0193 11.1754C14.7077 11.1754 14.4194 11.2318 14.1542 11.3445C13.8891 11.4571 13.6753 11.6179 13.5129 11.8267C13.3505 12.0322 13.2643 12.2775 13.2544 12.5625H11.4795C11.4927 11.9924 11.6568 11.492 11.9717 11.0611C12.2899 10.6269 12.7141 10.2888 13.2444 10.0469C13.7747 9.80161 14.3696 9.67898 15.0292 9.67898C15.7087 9.67898 16.2986 9.80658 16.7991 10.0618C17.3029 10.3137 17.6923 10.6534 17.9674 11.081C18.2425 11.5085 18.3801 11.9808 18.3801 12.4979C18.3834 13.0713 18.2143 13.5518 17.873 13.9396C17.5349 14.3274 17.0908 14.581 16.5406 14.7003V14.7798C17.2565 14.8793 17.805 15.1444 18.1862 15.5753C18.5706 16.0028 18.7612 16.5348 18.7579 17.1712C18.7579 17.7412 18.5955 18.2517 18.2707 18.7024C17.9492 19.1499 17.5051 19.5012 16.9383 19.7564C16.3749 20.0116 15.7285 20.1392 14.9994 20.1392Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_327_19624",
    x: 0,
    y: 0,
    width: 30,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_327_19624"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.1dd99b24699aa7412979bcbab4a5ce1a.svg";
export { ForwardRef as ReactComponent };